<div
  class="accordian-all-page app-payment-card-wrapper"
  [class.deleted-card]="isCardDeleted"
  [class.cursor-pointer]="clickable"
  [class.app-payment-card--drawer]="variant === 'drawer' || variant === 'compact'"
  [ngClass]="customClass"
  (click)="onCardClick($event)"
>
  <div class="main-content">
    <div class="py-3 px-1">
      <div class="row align-items-center">
        <!-- Main Column Area -->
        <div class="col-12">
          <div class="row align-items-center">
            
            <!-- ── VARIANT: FULL (Customer / List View) ── -->
            <ng-container *ngIf="variant === 'full'">
              <!-- Col 1: Tran ID -->
              <div class="col-md-2 col-6 col-payment-id">
                <div class="product-heading">
                  <h2 class="font-bold">TRAN. ID</h2>
                  <p class="mb-0 inv-date">{{ resolvedTranId }}</p>
                </div>
              </div>

              <!-- Col 2: Date -->
              <div class="col-md-2 col-6 col-payment-date">
                <div class="product-heading">
                  <h2 class="font-bold">DATE</h2>
                  <p class="mb-0 inv-date">{{ resolvedPaidDate | dateFormat }}</p>
                </div>
              </div>

              <!-- Col 3: Customer Name -->
              <div class="col-md-2 col-6 col-payment-customer">
                <div class="product-heading">
                  <h2 class="font-bold">CUSTOMER NAME</h2>
                  <p class="mb-0 inv-date" [title]="resolvedCustomerName">
                    {{ customerNameDisplay }}
                  </p>
                </div>
              </div>

              <!-- Col 4: Invoice Number -->
              <div class="col-md-2 col-6 col-payment-inv">
                <div class="product-heading">
                  <h2 class="font-bold">INVOICE NUMBER</h2>
                  <p class="mb-0 inv-date" [title]="resolvedInvoiceNumber">
                    {{ invoiceNumberDisplay }}
                  </p>
                </div>
              </div>

              <!-- Col 5: Tran Amount -->
              <div class="col-md-2 col-6 col-payment-amount">
                <div class="product-heading">
                  <h2 class="font-bold">TRAN. AMOUNT</h2>
                  <p class="mb-0 inv-date amount">{{ resolvedAmount | divide : '0.00' }}</p>
                </div>
              </div>
            </ng-container>

            <!-- ── VARIANT: DRAWER / COMPACT (Invoices Side Drawer / Modal View) ── -->
            <ng-container *ngIf="variant === 'drawer' || variant === 'compact'">
              <!-- Col 1: Tran ID -->
              <div class="col-md-1 col-6 col-payment-id">
                <div class="product-heading">
                  <h2 class="font-bold">TRAN. ID</h2>
                  <p class="mb-0 inv-date">{{ resolvedTranId }}</p>
                </div>
              </div>

              <!-- Col 2: Date -->
              <div class="col-md-2 col-6 col-payment-date">
                <div class="product-heading">
                  <h2 class="font-bold">DATE</h2>
                  <p class="mb-0 inv-date">{{ resolvedPaidDate | dateFormat }}</p>
                </div>
              </div>

              <!-- Col 3: Method -->
              <div class="col-md-2 col-6 col-payment-method">
                <div class="product-heading">
                  <h2 class="font-bold">METHOD</h2>
                  <p class="mb-0 inv-date">{{ resolvedMethod }}</p>
                </div>
              </div>

              <!-- Col 4: Payment Ref -->
              <div class="col-md-2 col-6 col-payment-ref">
                <div class="product-heading">
                  <h2 class="font-bold">PAYMENT REF.</h2>
                  <p class="mb-0 inv-date">{{ resolvedPaymentRef }}</p>
                </div>
              </div>

              <!-- Col 5: Tran Amount -->
              <div class="col-md-2 col-6 col-payment-amount">
                <div class="product-heading">
                  <h2 class="font-bold">TRAN. AMOUNT</h2>
                  <p class="mb-0 inv-date amount">{{ resolvedAmount | divide }}</p>
                </div>
              </div>
            </ng-container>

            <!-- ── VARIANT: CUSTOM (Array of custom fields) ── -->
            <ng-container *ngIf="variant === 'custom' && customFields">
              <div
                *ngFor="let f of customFields"
                class="col-payment-custom col-6"
                [ngClass]="f.class || 'col-md-2'"
              >
                <div class="product-heading">
                  <h2 class="font-bold">{{ f.label }}</h2>
                  <p
                    class="mb-0 inv-date"
                    [class.amount]="f.isAmount"
                    [title]="f.tooltip || ''"
                  >
                    <ng-container *ngIf="f.isDate">{{ f.value | dateFormat }}</ng-container>
                    <ng-container *ngIf="f.isAmount">{{ f.value | divide : '0.00' }}</ng-container>
                    <ng-container *ngIf="!f.isDate && !f.isAmount">{{ f.value || '-' }}</ng-container>
                  </p>
                </div>
              </div>
            </ng-container>

            <!-- Projected custom content (if passed) -->
            <ng-content></ng-content>

            <!-- ── Status Badges & Action Buttons (Far Right Column) ── -->
            <div
              class="col-actions col-12 d-flex align-items-center gap-1 ms-auto"
              [ngClass]="(variant === 'drawer' || variant === 'compact') ? 'col-md-3' : 'col-md-2'"
              (click)="$event.stopPropagation()"
            >
              <!-- Deleted Badge -->
              <div *ngIf="isCardDeleted" class="status-badge deleted mb-0 ms-auto">
                Deleted
              </div>

              <!-- Verified Badge -->
              <div *ngIf="isVerified" class="status-badge verified mb-0 ms-auto">
                Verified
              </div>

              <!-- Disputed Badge -->
              <div *ngIf="isDisputed" class="status-badge disputed mb-0">
                Disputed
              </div>

              <!-- Custom Slot for Badges / Additional Info -->
              <ng-content select="[badges]"></ng-content>

              <!-- Edit & Delete Action Buttons -->
              <div
                class="d-flex align-items-center gap-1 ms-auto"
                *ngIf="canShowActions"
                (click)="$event.stopPropagation()"
              >
                <ng-container *appHasAccess="accessPermission">
                  <!-- Edit Action -->
                  <app-edit-icon
                    *ngIf="showEditAction"
                    (click)="onEdit($event)"
                    title="Edit Payment">
                  </app-edit-icon>

                  <!-- Delete Action -->
                  <app-delete-icon
                    *ngIf="showDeleteAction"
                    (click)="onDelete($event)"
                    title="Delete Payment">
                  </app-delete-icon>
                </ng-container>

                <!-- Custom Actions Projected Slot -->
                <ng-content select="[actions]"></ng-content>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
